import React from 'react'
import ProductDetails from '../Components/ProductDetails'
import ChangePas from '../Components/ChangePas'

const Changepassword = () => {
  return<>
  <section className="product-details p-5">
    <div className="conntainer-xxl">
        <div className="row">
<ChangePas/>
        </div>
    </div>
  </section>
  </>
}

export default Changepassword